import { useParams, useHistory, Link } from 'react-router-dom';
import { fetchData, deleteData, activateData, postData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import React, { Fragment, useState, useContext, useEffect } from 'react';

const VehicleEdit = () => {
    const { id } = useParams();
    const recordId = useParams();
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const [VehicleTypeOptions, setVehicleTypeOptions] = useState([]);

    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);
    const [formData, setFormData] = useState({
        VehicletypeId: '',
        description: '',
        vehicleNo: '',
        taxDueDate: '',
        insuranceDueDate: '',
        serviceDueDate: '',
        permitValidity: '',
        polutionDueDate: '',
        tierChangeDate: '',
        additionalValidity: '',
        fitnessValidity: '',
        registrationValidity: '',
        insuranceCompany: '',
        advertisementValidity: '',
        remarks: '',
        vehicletype: '',
        chassisno: '',
        engineNo: '',
        rcOwner: '',
        driverName: '',
        isSubmit: false
    });
    //vehicle Type 

    //const [selectedRoute, setSelectedRoute] = useState("");
    const [vehicleOptions, setvehicleOptions] = useState([]);
    const [selectedVehicleType, setselectedVehicleType] = useState(null);

    const fetchvehicletype = async () => {
        try {
            const response = await fetchData('VehicleTypeApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(vehicleType => ({
                    value: vehicleType.id,
                    label: vehicleType.name
                }));
                setvehicleOptions(options);
            }
        } catch (error) {
            console.error('Error fetching vehicle:', error);
        }
    };
    const handlevehicleTypeChange = (selectedOption) => {
        setselectedVehicleType(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            VehicletypeId: selectedOption ? selectedOption.value : null,
        }));
    };

    useEffect(() => {
        fetchvehicletype();
    }, []);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        fetchData('VehicleApi', `/VehicleEdit/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data);
                    console.log(response);


                    const selectedvehicleoption = vehicleOptions.find(option => option.value === response.response_data.VehicletypeId);

                    setselectedVehicleType(selectedvehicleoption);

                }
            })
            .catch((error) => {
                console.error('Error fetching vehicle  Details:', error);
            });
    }, [id]);

    // useEffect(() => {
    //     fetchData('VehicleApi', `/VehicleRegistration/${id}`, token)
    //         .then((response) => {
    //             if (response.responseCode === '1111') {
    //                 // Destructure the response to get response_data
    //                 const { response_data } = response;
    //                 // Set form data
    //                 setFormData(response_data);

    //                 // Update form data with converted dates
    //                 setFormData(prevFormData => ({
    //                     ...prevFormData,


    //                 }));
    //             }
    //         })
    //         .catch((error) => {
    //             console.error('Error fetching Vehicle Details:', error);
    //         });
    // }, [id]);
    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        let month = (date.getMonth() + 1).toString();
        let day = date.getDate().toString();

        // Pad the month and day with leading zeros if needed
        month = month.length === 1 ? `0${month}` : month;
        day = day.length === 1 ? `0${day}` : day;

        return `${year}-${month}-${day}`;
    };

    const handleChange = (event) => {
        const { name, value, type } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? !prevData[name] : value,
        }));
    };



    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);
        setFormData(prevData => ({
            ...prevData,

            VehicletypeId: selectedVehicleType ? selectedVehicleType.value : null,
            UpdatedBy: userId,
        }));


        updateData('VehicleApi', `${id}`, formData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/VehicleRegistrationIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
                setIsLoading(false);
            });
    };

    // const handleSubmit = (event) => {
    //     event.preventDefault();
    //     setIsLoading(true);

    //     setFormData(prevData => ({
    //         ...prevData,
    //         UpdatedBy: userId,
    //     }));

    //     // Validate form data here if needed

    //     updateData('VehicleApi', `${id}`, formData, token)
    //         .then((response) => {
    //             console.log('Record updated successfully:', response.data);
    //             history.push('/ItemIndex');
    //         })
    //         .catch((error) => {
    //             console.error('Error updating record:', error);
    //             setIsLoading(false);
    //         });
    // };
    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto">
                <form onSubmit={handleSubmit}>
                    <div className='w-full mb-2 flex'>
                        <h6 className='uppercase productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>Vehicle Edit</h6>


                        <Tooltip title="Exit">
                            <Link to="/VehicleRegistrationIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                <Button style={{ color: 'red', fontWeight: 'bolder' }}>
                                    Back-To-List <ExitToAppIcon />
                                </Button>
                            </Link>
                        </Tooltip>
                        <Tooltip title="UPDATE">
                            <Button onClick={handleSubmit} style={{ color: 'green', fontWeight: 'bolder' }} disabled={isLoading}>
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"} <CheckCircleIcon />
                            </Button>
                        </Tooltip>
                    </div>
                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}
                    <br></br>
                    <div className="w-full mb-4 flex">
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Vehicle Type
                            </label>
                            <Select
                                //value={selectedRouteType}
                                value={selectedVehicleType || (formData.vehicleType ? { value: formData.vehicleType, label: formData.vehicleType } : '')}

                                onChange={handlevehicleTypeChange}
                                options={vehicleOptions}
                                placeholder="VehicleOptions"
                                isSearchable
                            />

                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Vehicle Name
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.description}
                                name="description"
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter Name"
                            />


                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                VehicleNo
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.vehicleNo}
                                name="vehicleNo"
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter Vehicle No"
                            />

                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Driver Name
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.driverName}
                                name="driverName"
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter Driver Name"
                            />


                        </div>


                    </div>

                    <div className="w-full mb-4 flex">
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Engine No
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.engineNo}
                                name="engineNo"
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter Engine No"
                            />

                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                RC Owner
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.rcOwner}
                                name="rcOwner"
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter RC Owner"
                            />

                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Insurance Company
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.insuranceCompany}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter Insurance Company"
                            />

                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Chassis No
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.chassisNo}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter Chassis No"
                            />

                        </div>
                    </div>


                    <div className="w-full mb-4 flex">
                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Tax Due Date
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date"
                                value={formatDateForInput(formData.taxDueDate)}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Insurance Due Date
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date"
                                value={formatDateForInput(formData.insuranceDueDate)}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Service Due Date
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date"
                                value={formatDateForInput(formData.serviceDueDate)}
                                onChange={handleChange}
                            />
                        </div>


                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Pollution Due Date
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date" value={formatDateForInput(formData.polutionDueDate)}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Tyre Change Date
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date" value={formatDateForInput(formData.tierChangeDate)}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Permit Validity
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date" value={formatDateForInput(formData.permitValidity)}
                                onChange={handleChange}
                            />

                        </div>

                    </div>

                    <div className="w-full mb-4 flex flex-wrap">


                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Additional Validity
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date"
                                value={formatDateForInput(formData.additionalValidity)}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Fitness Validity
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date" value={formatDateForInput(formData.fitnessValidity)}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Registration Validity
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date"
                                value={formatDateForInput(formData.registrationValidity)}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Advertisement Validity
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date"
                                value={formatDateForInput(formData.advertisementValidity)}
                                onChange={handleChange}
                            />

                        </div>
                    </div>

                    {/* <div className="w-1/4 mr-2">
                        <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="remarks">
                            Remarks
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={formData.remarks}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter Remarks"
                        />

                    </div> */}

                    <div className="w-1/2 mb-4 flex flex-col">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            Remarks
                        </label>
                        <textarea
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={formData.remarks}
                            onChange={handleChange}
                            placeholder="Enter Remarks"
                            rows="4"
                        />
                    </div>






                </form>
            </div>

        </Fragment >
    );
};
export default VehicleEdit;

